import { computed } from '@angular/core';
import { signalStoreFeature, withComputed, withState } from '@ngrx/signals';
import { PermissionEnum } from '@core/enums/permission.enum';
import { IUser } from '@core/models/interfaces/user.interface';
import { ITimebank } from '@shared/models/interfaces/timebank.interface';
import { IWeekWorktime } from '@shared/models/interfaces/week-worktime.interface';

export interface CurrentUserState {
  user: IUser | undefined;
  userWorktime: IWeekWorktime[] | undefined;
  userTimebank: ITimebank | undefined;
  retrieveUserCompleted: boolean;
}

export const INITIAL_CURRENT_USER_STATE: CurrentUserState = {
  user: undefined,
  userWorktime: undefined,
  userTimebank: undefined,
  retrieveUserCompleted: false
};

export const resetCurrentUser = (): CurrentUserState => ({ ...INITIAL_CURRENT_USER_STATE });

/**
 * No methods: every user mutation is cross-slice (it touches loginError too) and lives in
 * CoreStore.
 */
export function withCurrentUser() {
  return signalStoreFeature(
    withState<CurrentUserState>(INITIAL_CURRENT_USER_STATE),
    withComputed(({ user, userTimebank }) => ({
      userId: computed(() => user()?.id),
      userEmail: computed(() => user()?.email),
      userPermissions: computed<PermissionEnum[]>(() => user()?.permission ?? []),
      timebankTime: computed(() => userTimebank()?.time ?? 0),
      isLogged: computed(() => !!user())
    }))
  );
}
